const hasOffset = (searchString: string) => {
  const urlSearchParams = new URLSearchParams(searchString);
  return urlSearchParams && urlSearchParams.getAll('offset').length > 0;
};

export { hasOffset };
